export function getCookie(name) {
    const dc = document.cookie.split('; ');
    for (let i = 0, l = dc.length; i < l; i++) {
        const c = dc[i].split('=');
        if (c[0] === name) {
            return c[1].split(';')[0];
        }
    }
    return false;
}

export function setCookie(name, val, exp) {
    const encodedValue = encodeURI(val);

    const d = new Date();
    d.setDate(d.getDate() + exp);

    let value = encodedValue + (exp === null ? '' : '; expires=' + d.toUTCString()) + '; path=/';

    if (exp === 0) {
        value = encodedValue + '; path=/';
    }
    document.cookie = name + '=' + value;
    return encodedValue;
}

export function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
